module.exports = __webpack_public_path__ + "static/media/pause.366a819c.png";


//////////////////
// WEBPACK FOOTER
// ./src/workout/pause.png
// module id = 2029
// module chunks = 0